import { Redirect, Switch, useRouteMatch } from "react-router-dom";
import { DefaultLayout } from "../DefaultLayout";
import { PrivateRoute } from "../../auth/PrivateRoute";
import { ReportTeam } from "../../projectManagement/components/reportApproverAgenda/ReportTeam";

import { AnimateSharedLayout } from "framer-motion";
import ReportWritersAgenda from "../../projectManagement/components/reportWritersAgenda/ReportWritersAgenda";
import { ReportsList } from "./Reports";
import { PreWritterQueuePage } from "../../projectManagement/preWritterQueue/PreWritterQueuePage";
import { ReportApproversAgenda } from "../../projectManagement/components/reportApproverAgenda/ReportApproversAgenda";
import RSDList from "../../projectManagement/components/reportSequenceDefinitions/RSDList";
import NewRSD from "../../projectManagement/components/reportSequenceDefinitions/NewRSD";
import RSDExisting from "../../projectManagement/components/reportSequenceDefinitions/RSDExisting";
import RSDDetails from "../../projectManagement/components/reportSequenceDefinitions/RSDDetails";
import { ReportTeamView } from "../../projectManagement/components/reportApproverAgenda/ReportTeamView";
import { EditReportTeam } from "../../projectManagement/components/reportApproverAgenda/EditReportTeam";
import TipTap from "../../projectManagement/components/reportWritersAgenda/TipTap/TipTap";
import { UploadTipTapEditor } from "../../projectManagement/components/reportWritersAgenda/UploadEditor/UploadTipTapEditor";
import { ReportDocumentUpload } from "../../projectManagement/components/reportWritersAgenda/ReportDocumentUpload";
import WritersAgendaV2 from "../../projectManagement/components/writersAgendaV2";
import { DocumentTemplateList } from "../../projectManagement/components/reportWritersAgenda/UploadEditor/DocumentTemplateList";
import { ChecklistUpload } from "../../projectManagement/components/reportWritersAgenda/ChecklistUpload";

export const ReportRoute = () => {
  const { path } = useRouteMatch();

  return (
    <>
      <DefaultLayout>
        <AnimateSharedLayout>
          <Switch>
            <PrivateRoute exact path={`${path}`} component={ReportsList} />

            <PrivateRoute
              exact
              path={`${path}/report_team`}
              component={ReportTeamView}
            />

            <PrivateRoute
              exact
              path={`${path}/report_team/add_report_team`}
              component={ReportTeam}
            />

            <PrivateRoute
              exact
              path={`${path}/report_team/:reportTeamId`}
              component={EditReportTeam}
            />

            <PrivateRoute
              exact
              path={`${path}/report_writers_agenda`}
              component={ReportWritersAgenda}
            />

            <PrivateRoute
              exact
              path={`${path}/report_approver_agenda`}
              component={ReportApproversAgenda}
            />

            <PrivateRoute
              exact
              path={`${path}/pre_writers_queue`}
              component={PreWritterQueuePage}
            />

            <PrivateRoute
              exact
              path={`${path}/report_sequence_definition`}
              component={RSDList}
            />
            <PrivateRoute
              exact
              path={`${path}/report_sequence_definition/new_rsd`}
              component={NewRSD}
            />
            <PrivateRoute
              exact
              path={`${path}/report_sequence_definition/rsd`}
              component={RSDExisting}
            />
            <PrivateRoute
              exact
              path={`${path}/report_sequence_definition/:tsdId`}
              component={RSDDetails}
            />
            <PrivateRoute
              exact
              path={`${path}/report_module`}
              component={WritersAgendaV2}
            />
            <PrivateRoute
              exact
              path={`${path}/report_writers_agenda/tiptap/:id`}
              component={TipTap}
            />

            <PrivateRoute
              exact
              path={`${path}/report_document/`}
              component={DocumentTemplateList}
            />

            <PrivateRoute
              exact
              path={`${path}/report_document/report_document_upload/`}
              component={ReportDocumentUpload}
            />
            <PrivateRoute
              exact
              path={`${path}/checklist_upload/`}
              component={ChecklistUpload}
            />
            <PrivateRoute
              exact
              path={`${path}/report_document_upload/report_preview_editor/:template_id`}
              component={UploadTipTapEditor}
            />

            <Redirect to="/not_found" />
          </Switch>
        </AnimateSharedLayout>
      </DefaultLayout>
    </>
  );
};
